// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PropsWithChildren, useMemo } from 'react';
import { useConfig } from '../hooks/other/useConfig';
import portfolio from '../themes/portfolio';
import utilities from '../themes/utilities';
import { BrandingContext } from './BrandingContext';

const options = {
  utilities,
  portfolio,
};

export const BrandingProvider = ({ children }: PropsWithChildren) => {
  const config = useConfig();
  const state = useMemo(() => options[config.branding.theme], [config]);

  return <BrandingContext.Provider value={state}>{children}</BrandingContext.Provider>;
};
